import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NuovoMontaggio from "@/pages/NuovoMontaggio";
import Storico from "@/pages/Storico";
import Anagrafica from "@/pages/Anagrafica";
import Pianificazione from "@/pages/Pianificazione";
import Macchine from "@/pages/Macchine";
import Magazzino from "@/pages/Magazzino";
import Riordini from "@/pages/Riordini";
import Ordini from "@/pages/Ordini";
import Impianti from "@/pages/Impianti";
import Elettrici from "@/pages/Elettrici";
import ResetPassword from "@/pages/ResetPassword";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]">
      <div className="h-10 w-10 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function Protected({ children, adminOnly, warehouseOnly }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (warehouseOnly && user.role !== "admin" && !user.warehouse_access) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/nuovo" element={<Protected><NuovoMontaggio /></Protected>} />
      <Route path="/macchine" element={<Protected><Macchine /></Protected>} />
      <Route path="/impianti" element={<Protected><Impianti /></Protected>} />
      <Route path="/elettrici" element={<Protected><Elettrici /></Protected>} />
      <Route path="/pianificazione" element={<Protected><Pianificazione /></Protected>} />
      <Route path="/storico" element={<Protected><Storico /></Protected>} />
      <Route path="/magazzino" element={<Protected warehouseOnly><Magazzino /></Protected>} />
      <Route path="/riordini" element={<Protected warehouseOnly><Riordini /></Protected>} />
      <Route path="/ordini" element={<Protected adminOnly><Ordini /></Protected>} />
      <Route path="/anagrafica" element={<Protected adminOnly><Anagrafica /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
